import ResolveMultiSelect from './ResolveMultiSelect.component';

export default ResolveMultiSelect;